import React, {useEffect, useState} from "react";
import {Button, Layout, message, Popover} from "antd";
import {Link} from "react-router-dom";
import {toggleCollapsedSideNav} from "../../appRedux/actions/Setting";
//import SearchBox from "../../components/SearchBox";
import AppNotification from "../../components/AppNotification";

import {NAV_STYLE_DRAWER, NAV_STYLE_FIXED, NAV_STYLE_MINI_SIDEBAR, TAB_SIZE} from "../../constants/ThemeSetting";
import {useDispatch, useSelector} from "react-redux";
import {stopImpersonate, unreadNotify} from "../../appRedux/actions";
import axiosJSON from "../../util/SetHeaderAPI";
import Impersonation from "../../modals/impersonation";
import PersonalActivity from "../../components/PersonalActivity";
import BugReporter from 'bug-reporter-react'
import { DASHBOARD_URL } from "../../util/Api";

const {Header} = Layout;

const Topbar = (props) => {
  // axiosJSON.defaults.headers['authorization'] = "Token " + localStorage.getItem('token');
  const {width, navCollapsed, navStyle} = useSelector(({settings}) => settings);
  const {unread_notify} = useSelector(({common}) => common);
  const authUser = useSelector(({auth}) => auth.authUser);
  const newUser = useSelector(({auth}) => auth.newUser);
  const impersonateFlag = useSelector(({auth}) => auth.impersonateFlag);

  //const [searchText, setSearchText] = useState('');
  const [notificationList, setNotificationList] = useState([]);
  const [visible, setVisible] = useState(false);
  const [activityVisible, setActivityVisible] = useState(false);
  const [impersonateButton, openImpersonate] = useState(false);
  const dispatch = useDispatch();
  // const updateSearchChatUser = (evt) => {
  //   evt.preventDefault()
  //   setSearchText(evt.target.value);
  // };

  const hide = () => {
    setVisible(false);
    setActivityVisible(false)
  };

  const handleVisibleChange = visible => {
    if (visible) {
      let currentToken = localStorage.getItem("current_token");
      let token = localStorage.getItem("token");
      if (currentToken && impersonateFlag) {
        fetchData(currentToken)
      } else {
        fetchData(token)
      }
    }
    setVisible(visible);
  };

  const handleActivityChange = visible =>{
    setActivityVisible(visible)
  }

  const stopImpersonation = () => {
    dispatch(stopImpersonate());
  }

  const closeModal = () =>{
    openImpersonate(false)
    window.location.reload()
  }

  const fetchData = (token) => {
    setNotificationList([])
    axiosJSON.defaults.headers['authorization'] = "Token " + token;
    axiosJSON.get('api/notification/?page=1')
      .then(res => {
        const notf = res.data.data
        dispatch(unreadNotify(res.data.count))
        setNotificationList(notf)
      }).catch(function (error) {
      message.error(error.message)
    })
  }

  useEffect(() => {
    let currentToken = localStorage.getItem("current_token");
    let token = localStorage.getItem("token");
    if (currentToken && impersonateFlag) {
      fetchData(currentToken)
    } else {
      fetchData(token)
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const getStatus = (data,flag) =>{
    if(flag){
      message.success("Bug reported successfully !!!",[0.5])
    }else{
      message.error(data,[0.5])
    }
  }


  return (
    <Header >
      {navStyle === NAV_STYLE_DRAWER || ((navStyle === NAV_STYLE_FIXED || navStyle === NAV_STYLE_MINI_SIDEBAR) && width < TAB_SIZE) ?
        <div className="gx-linebar gx-mr-3">
          <i className="gx-icon-btn icon icon-menu"
             onClick={() => {
               dispatch(toggleCollapsedSideNav(!navCollapsed));
             }}
          />
        </div> : null}
      <Link to="/" className="gx-d-block gx-d-lg-none gx-pointer">
        <img style={{width: '30%', height: '10%'}} alt="" src={require("assets/images/logo-white.png")}/></Link>
      {
        newUser &&
        <div className="ant-row">
          <h3 className="gx-text-white">Impersonated user : {newUser.name}</h3>
        </div>
      }
      {/*<SearchBox styleName="gx-d-none gx-d-lg-block gx-lt-icon-search-bar-lg"*/}
      {/*           placeholder="Search in app..."*/}
      {/*           onChange={updateSearchChatUser}*/}
      {/*           value={searchText}/>*/}
      <ul className="gx-header-notifications gx-ml-auto">
        <li className="gx-notify gx-notify-search gx-d-inline-block gx-d-lg-none">
          {/*<Popover overlayClassName="gx-popover-horizantal" placement="bottomRight" content={*/}
          {/*  <SearchBox styleName="gx-popover-search-bar"*/}
          {/*             placeholder="Search in app..."*/}
          {/*             onChange={updateSearchChatUser}*/}
          {/*             value={searchText}/>*/}
          {/*} trigger="click">*/}
          {/*  <span className="gx-pointer gx-d-block"><i className="icon icon-search-new"/></span>*/}
          {/*</Popover>*/}
        </li>
        <li>
          {authUser && authUser.is_superuser ?
            !impersonateFlag ?
              <Button className="gx-my-0" onClick={() => {
                openImpersonate(true)
              }}>Impersonate</Button>
              : <Button className="gx-my-0" onClick={() => {
                stopImpersonation()
              }}> Stop Impersonate</Button>
            : null
          }
        </li>
        <li className="gx-msg">
          <Popover overlayClassName="gx-popover-horizantal" placement="bottomRight" style={{left:'1042px',top:'50px',width:'400px'}}
                   content={
                     <PersonalActivity
                       hide={hide}
                       history={props.history}/>}
                   visible={activityVisible}
                   onVisibleChange={handleActivityChange}
                   trigger="click">
               <span className="gx-pointer gx-status-pos gx-d-block">
            <i className="icon icon-timepicker"/>
               </span>
          </Popover></li>
        <li className="gx-msg">
          <Popover overlayClassName="gx-popover-horizantal" placement="topRight"
                   content={
                     <AppNotification
                       notificationList={notificationList}
                       fetchData={fetchData} visible={visible} hide={hide} history={props.history}/>}
                   visible={visible}
                   onVisibleChange={handleVisibleChange}
                   trigger="click">
               <span className="gx-pointer gx-status-pos gx-d-block">
            <i className="icon icon-notification"/>
                 {unread_notify > 0 &&
                 <span
                   className={`gx-status gx-status-rtl gx-font-small ${unread_notify.length > 100 ? `gx-xlarge` : unread_notify.length > 10 ? `gx-large` : 'gx-medium'}  gx-orange`}>{unread_notify}</span>}
               </span>
          </Popover></li>
      </ul>

      {
        impersonateButton &&
        <Impersonation impersonateButton={impersonateButton} openImpersonate={openImpersonate} closeModal={closeModal} />
      }
      <BugReporter
        buttonStyle={{ position: "fixed", bottom: 500, right: 200 }}
        url={DASHBOARD_URL}
        name={props.authInfo?props.authInfo.name:"None"}
        email={props.authInfo?props.authInfo.email:"None"}
        appName={"Beats"}
        getStatus={getStatus}
      />
    </Header>
  );
};

export default React.memo(Topbar);
